// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DraftBanner_wrapper___1fMp","sidebarOpen":"DraftBanner_sidebarOpen__SgK4h"};